import React, {useState, Fragment, useEffect, useRef} from "react";
import Moment from "react-moment";
import moment from "moment";
import CustomToolbar from "../../../CustomToolbar";
import FilterComponent from "./FilterCabinetComponent.js";
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Button,
  AppBar,
  Typography,
  Toolbar,
  Grid,
  Dialog,
  TextField,
  IconButton,
  FormControlLabel,
  Switch,
  Stepper,
  Step,
  StepLabel,
  Box,
  CircularProgress,
} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";
import {MuiThemeProvider} from "@material-ui/core/styles";
import {pricesDataTableTheme} from "assets/css/datatable-theme.js";
import Autocomplete from "@material-ui/lab/Autocomplete";
import {Close, Save, Search, Check, Add} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";
import MUIDataTable from "mui-datatables";
import {getCookie} from "../../../components/auth/Helpers";
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "react-dropzone-uploader/dist/styles.css";
import "../LiveOperation.css";
import axios from "axios";

const useStyles = makeStyles((theme) => ({
  appBar: {position: "relative", marginBottom: 20},
  title: {marginLeft: theme.spacing(2), flex: 1},
  formControl: {minWidth: "100%"},
}));

const AddOperationForm = (props) => {
  const token = getCookie("token");
  const classes = useStyles(); //custom css
  const [formValues, setFormValues] = useState({
    operationType: props.type ?? null,
    to_warehouse: "",
    from_warehouse: "",
    warehouse: "",
    store1: "",
    store: "",
    serviceType: "",
    with_3pl_fleet: 1,
  });
  const [warehousesList, setWarehousesList] = useState({});
  const [storesList, setStoresList] = useState({});
  const [citiesList, setCitiesList] = useState({});
  const [warehouseValue, setWarehouseValue] = useState({});
  const [fromWarehouseValue, setFromWarehouseValue] = useState({});
  const [toWarehouseValue, setToWarehouseValue] = useState({});
  const [loading, setLoading] = useState(true);
  const [tiersList, setTiersList] = useState({});
  const [cityOut, setCityOut] = useState({});
  const [tierOut, setTierOut] = useState({});
  const [store1Value, setStore1Value] = useState([]);
  const [storeValue, setStoreValue] = useState([]);

  const [filterDialog, setFilterDialog] = useState(false);
  const [fridgesTypesList, setFridgesTypesList] = useState({});
  const [cabinetsList, setCabinetsList] = useState({});
  const [clientsList, setClientsList] = useState({});
  const [countriesList, setCountriesList] = useState({});
  const [serviceTypeValue, setServiceTypeValue] = useState({});
  const [serviceTypeList, setServiceTypeList] = useState({});
  const [prices, setPrices] = useState([]);
  const [operationsList, setOperationsList] = useState([]);
  const [neighbourhoodsList, setNeighbourhoodsList] = useState([]);

  const [cabinetsPagingInfo, setCabinetsPagingInfo] = useState({page: 0, limit: 20, skip: 0, count: 0}); //Pagination Info
  const [currentDate, setCurrentDate] = useState(new Date()); //table items
  const [snFilled, setSnFilled] = useState(props.fridges ? props.fridges.map((fridge) => fridge.sn) : []);
  const [openSearch, setOpenSearch] = useState(false);
  const [openPrices, setOpenPrices] = useState(false);
  const [columnsForPrices, setColumnsForPrices] = useState(false);
  //After Save
  const [selectedSn, setSelectedSn] = useState([]);
  const [saveClicked, setSaveClicked] = useState(1);

  const steps = ["Retrieval", "Deployment"];
  const [activeStep, setActiveStep] = useState(0);
  const statusList = ["Operational", "Quarantine", "Major Maintenance", "Damaged", "Discontinued"];
  const handleNext = () => {
    if (activeStep < steps.length - 1) setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };
  const renderStepContent = (step) => {
    switch (step) {
      case 0:
        return <Typography>Form content for Step 1</Typography>;
      case 1:
        return <Typography>Form content for Step 2</Typography>;
      default:
        return null;
    }
  };

  const optionsForPrices = {
    filter: false,
    selectableRows: false,
    rowsPerPage: 100,
    customFooter: () => "",
  };
  const handleCloseOpenPrices = () => {
    // return console.log("props.setPricesToUse",pricesForFinance)
    setValuesFiltered([]);
    setPricesForFinance([]);
    setSaveClicked(1);
    setOpenPrices(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      await axios
        .all([
          axios.get(`${process.env.REACT_APP_BASE_URL}/operations`, {
            headers: {Authorization: `Bearer ${token}`},
          }),

          axios.get(`${process.env.REACT_APP_BASE_URL}/cities`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/warehouses`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/stores`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/fridgesTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/serviceTypes`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/clients`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
          axios.get(`${process.env.REACT_APP_BASE_URL}/countries`, {
            headers: {Authorization: `Bearer ${token}`},
          }),

          axios.get(`${process.env.REACT_APP_BASE_URL}/tiers`, {headers: {Authorization: `Bearer ${token}`}}),

          axios.get(`${process.env.REACT_APP_BASE_URL}/neighbourhoods`, {
            headers: {Authorization: `Bearer ${token}`},
          }),
        ])
        .then((response) => {
          setOperationsList(response[0].data);
          setCitiesList(response[1].data);
          setWarehousesList(response[2].data);
          setStoresList(response[3].data);
          setFridgesTypesList(response[4].data);
          setServiceTypeList(response[5].data.data);
          setClientsList(response[6].data);
          setCountriesList(response[7].data);

          setTiersList(response[8].data);
          setNeighbourhoodsList(response[9].data);

          setLoading(false);
        });
    };
    fetchData();
  }, []);

  const handleChangeTextfield = (e, n) => {
    const {name, value} = e.target;
    let v = value;
    let r = 0;
    if (value == "Swap") {
      v = "Retrieval";
      r = 1;
    }

    if (name == "operationType" && value != "Swap" && formValues.replacement != 1) {
      setFormValues((prev) => ({
        ...prev,
        operationType: props.type ?? null,
        to_warehouse: "",
        from_warehouse: "",
        warehouse: "",
        store1: "",
        store: "",
        serviceType: "",
        with_3pl_fleet: 1,
        [name]: v,
        replacement: r,
      }));

      setWarehouseValue({});
      setToWarehouseValue({});
      setFromWarehouseValue({});
      setStore1Value({});
      setStoreValue({});
      setSnFilled([]);
      setSelectedSn([]);
    } else {
      setFormValues({...formValues, [name]: v, replacement: r});
    }
  };

  const handleChangeValue = (e, n) => {
    const {name, value} = e.target;

    setFormValues({...formValues, [name]: value});
  };

  const handleChangeCheckbox = (e) => {
    const {name, checked} = e.target;

    setFormValues({...formValues, [name]: checked});
  };

  const handleChangeAutoComplete = (e, newValue, name) => {
    switch (name) {
      case "from_warehouse":
        setFromWarehouseValue(newValue);
        break;

      case "to_warehouse":
        setToWarehouseValue(newValue);
        break;

      case "warehouse":
        setWarehouseValue(newValue);
        break;
      case "store1":
        setStore1Value(newValue);
        break;
      case "store":
        setStoreValue(newValue);
        break;
      case "serviceType":
        setServiceTypeValue(newValue);
        break;
    }
    if (newValue) setFormValues({...formValues, [name]: newValue._id});
  };

  const cityValueFirstRun = useRef(true);
  useEffect(() => {
    setSaveClicked(1);
    if (cityValueFirstRun.current) {
      cityValueFirstRun.current = false;
    } else {
      const tierObj = tiersList.filter((e) => {
        let returnBolean = false;
        e.cities.forEach((e) => {
          if (e.name === cityOut.name) returnBolean = true;
        });
        return returnBolean;
      });
      setTierOut(tierObj.length ? tierObj[0]?.name : "");
    }
  }, [cityOut]);

  const handleOpenSearch = () => {
    setOpenSearch(true);
    // setCabinetsList(
    //   cabinetsList.filter((e) => {
    //     let showRow = true;
    //     if (e.booked) return false;
    //     snFilled.forEach((sn) => {
    //       //change Sn
    //       if (sn == e.sn) showRow = false;
    //     });
    //     return showRow;
    //   })
    // );

    setCabinetsList((prev) => {
      if (!Array.isArray(prev)) return [];
      return prev.filter((e) => {
        if (e.booked) return false;
        return !snFilled.includes(e.sn);
      });
    });
  };

  const handleAddSns = () => {
    let q = parseInt(formValues.quantity);
    if (cabinetsList.length == 0) {
      toast.error("No Cabinets available");
    } else {
      let foundCabinets = cabinetsList.filter((c) => c.type == formValues.fridgesType);
      console.log("foundCabinets = > ", foundCabinets);

      if (foundCabinets.length == 0) {
        toast.error("None Found");
      } else if (foundCabinets.length < q) {
        toast.error(`Not Enough Quantity, only ${foundCabinets.length} found`);
      } else {
        setFormValues((prev) => ({
          ...prev,
          fridgesType: "",
          quantity: "",
        }));

        foundCabinets.forEach((cab, i) => {
          if (i < q) {
            setSnFilled((prevSN) => [...prevSN, cab.sn]);
            setSelectedSn((prevSelectedSn) => [
              ...prevSelectedSn,
              ...cabinetsList.filter((eSub) => cab._id.includes(eSub._id)),
            ]);
          }
        });
      }
    }
  };

  const groupSNsByType = (snList) => {
    const grouped = {};
    snList.forEach((sn) => {
      if (!grouped[sn.type]) grouped[sn.type] = [];
      grouped[sn.type].push(sn._id);
    });
    console.log("grouped ", grouped);
    return grouped;
  };

  useEffect(() => {
    console.log("cabinetsList ==>", cabinetsList);
  }, [cabinetsList]);

  const handleFilter = () => {
    setFilterDialog(true);
  };

  const handleExport = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/cabinets/export?operationType=${
          formValues.operationType
        }&from_warehouse=${formValues.from_warehouse ? formValues.from_warehouse : null}&warehouse=${
          formValues.warehouse ? formValues.warehouse : null
        }&condition=${formValues.condition ?? null}&status=${formValues.status ?? null}`,
        {
          responseType: "blob",
          headers: {Authorization: `Bearer ${token}`},
        }
      );

      // ✅ Create blob and download using anchor
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Cabinets.xlsx"); // filename
      document.body.appendChild(link);
      link.click();

      // ✅ Cleanup
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Export failed", err);
    }
  };

  const optionsForSn = {
    filter: false,
    selectToolbarPlacement: "replace",
    rowsPerPage: 10, // Ensure this is correctly tied to state
    rowsPerPageOptions: [10, 20, 50, 100, 150],
    download: false,

    customToolbar: () => {
      return <CustomToolbar handleFilter={handleFilter} handleExport={handleExport} />;
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      return (
        <IconButton
          onClick={() => {
            const selectedRowsTotal = selectedRows.data.map((e) => e.dataIndex);
            selectedRowsTotal.forEach((e) => {
              //change Sn
              setSnFilled((prevSN) => [...prevSN, cabinetsList[e].sn]);
              setSelectedSn((prevSelectedSn) => [
                ...prevSelectedSn,
                ...cabinetsList.filter((eSub) => cabinetsList[e]._id.includes(eSub._id)),
              ]);
            });
            setOpenSearch(false);
          }}
          style={{marginRight: "24px", height: "48px", display: "block"}}
        >
          <Save />
        </IconButton>
      );
    },
    textLabels: {
      body: {
        noMatch: "Sorry, there is either no matching fridges to display or the items may already be booked.",
      },
    },
    // serverSide: true,
    // count: cabinetsPagingInfo.count, //
    // page: cabinetsPagingInfo.page,
    // onTableChange: (action, tableState) => {
    //   if (action === "changePage") {
    //     setCabinetsPagingInfo({
    //       ...cabinetsPagingInfo,
    //       page: tableState.page,
    //       skip: tableState.page * cabinetsPagingInfo.limit,
    //     });
    //   } else if (action === "changeRowsPerPage") {
    //     setCabinetsPagingInfo({...cabinetsPagingInfo, limit: tableState.rowsPerPage});
    //   }
    // },
  };
  const handleChangeSn = (event, newValue, type = null) => {
    const acceptedSn = type
      ? cabinetsList.filter((e) => newValue.includes(e.sn) || e.type != type)
      : cabinetsList.filter((e) => newValue.includes(e.sn));
    setSnFilled(acceptedSn.map((e) => e.sn));
    setSelectedSn(acceptedSn);
  };

  useEffect(() => {
    console.log("selectedSn = > ", selectedSn);
  }, [selectedSn]);
  useEffect(() => {
    console.log("snFilled = > ", snFilled);
  }, [snFilled]);

  useEffect(() => {
    console.log("warehouseValue = > ", warehouseValue);
  }, [warehouseValue]);
  useEffect(() => {
    console.log("toWarehouseValue = > ", toWarehouseValue);
  }, [toWarehouseValue]);
  useEffect(() => {
    console.log("fromWarehouseValue = > ", fromWarehouseValue);
  }, [fromWarehouseValue]);
  useEffect(() => {
    console.log("storeValue = > ", storeValue);
  }, [storeValue]);
  useEffect(() => {
    console.log("store1Value = > ", store1Value);
  }, [store1Value]);

  const cabinetFilterFirstRun = useRef(true);
  useEffect(() => {
    setSaveClicked(1);
    if (cabinetFilterFirstRun.current) {
      cabinetFilterFirstRun.current = false;
    } else {
      const fetchData = async () => {
        await axios(
          `${process.env.REACT_APP_BASE_URL}/cabinets?operationType=${
            formValues.operationType
          }&from_warehouse=${formValues.from_warehouse ? formValues.from_warehouse : null}&warehouse=${
            formValues.warehouse ? formValues.warehouse : null
          }&condition=${formValues.condition ?? null}&status=${formValues.status ?? null}`,
          {
            responseType: "json",
            headers: {Authorization: `Bearer ${token}`},
          }
        ).then((response) => {
          setCabinetsList(response.data.data);
        });
      };
      fetchData();
    }
  }, [
    formValues.operationType,
    formValues.from_warehouse,
    formValues.condition,
    formValues.status,
    formValues.warehouse,
  ]);

  const pricesFirstRun = useRef(true);
  useEffect(() => {
    if (pricesFirstRun.current) {
      pricesFirstRun.current = false;
    } else {
      setColumnsForPrices([
        {
          name: "validPrice",
          label: "Valid Price Rule",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (tableMeta.rowData[15] === "Total") {
                return "";
              }
              return Object.keys(value).length ? (
                <Check className="text-success" />
              ) : (
                <Close className="text-danger" />
              );
            },
          },
        },
        {
          name: "sn",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (value) {
                let snValue = cabinetsList.filter((e) => e._id == value);
                return snValue.length ? snValue[0].sn : "-";
              }
            },
          },
        },
        {name: "price_rule_name", label: "Price Rules Name"},
        {name: "client_name", label: "Client Name"},
        {name: "handling_in", label: "Handling In"},
        {name: "storage", label: "Storage"},
        {
          name: "in_house_preventive_maintenance",
          label: "Inhouse Preventive Maintena",
        },
        {
          name: "corrective_service_in_house",
          label: "Corrective Service Inhouse",
        },
        {name: "cabinet_testing_fees", label: "Cabinet Testing Fees"},
        {name: "branding_fees", label: "Branding Fees"},
        {name: "drop", label: "drop"},
        {name: "installation", label: "Installation"},
        {name: "transportation_fees", label: "Transportation Fees"},
        {name: "preventive_maintenance", label: "Preventive Maintenance"},
        {
          name: "exchange_corrective_reaction",
          label: "Exchange Corrective Reaction",
        },
        {
          name: "corrective_reaction",
          label: "Corrective Reaction",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (value === "Total") return <strong>Total</strong>;
              return value;
            },
          },
        },
        {
          name: "total",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              if (tableMeta.rowData[15] === "Total") {
                let allNumbers = tableMeta.tableData.map((e) => e[15]).filter((e) => typeof e === "number");
                let sumOfAll = allNumbers.length ? allNumbers.reduce((a, b) => a + b) : 0;
                return sumOfAll;
              }
              return value;
            },
          },
        },
      ]);
      setOpenPrices(true);

      props.setPricesToUse(prices);
    }
  }, [prices]);

  const [valuesFiltered, setValuesFiltered] = useState([]);
  const [pricesForFinance, setPricesForFinance] = useState([]);

  const valuesFilteredFirstRun = useRef(true);
  useEffect(() => {
    if (valuesFilteredFirstRun.current) {
      valuesFilteredFirstRun.current = false;
    } else {
      if (pricesForFinance.length) {
        const fetchData = async () => {
          let pricesForFinance1 = pricesForFinance;
          if (pricesForFinance.length > 1) {
            let totalFeez = pricesForFinance.reduce((a, b) => a.transportation_fees + b.transportation_fees);
            let totalCBM = pricesForFinance.reduce((a, b) => a.cbm + b.cbm);
            let minCharge = pricesForFinance[0].min_charge;
            if (totalFeez < minCharge) {
              pricesForFinance1 = pricesForFinance.map((e) => {
                e.transportation_fees = (e.cbm * minCharge) / totalCBM;
                return e;
              });
            }
          }
          pricesForFinance1 = pricesForFinance1.map((e) => {
            return {
              validPrice: e.validPrice,
              sn: e.sn,
              price_rule_name: e.price_rule_name,
              client_id: e.client_id,
              client_name: e.client_name,
              branding_fees: e.branding_fees,
              cabinet_testing_fees: e.cabinet_testing_fees,
              corrective_reaction: e.corrective_reaction,
              corrective_service_in_house: e.corrective_service_in_house,
              drop: e.drop,
              exchange_corrective_reaction: e.exchange_corrective_reaction,
              handling_in: e.handling_in,
              in_house_preventive_maintenance: e.in_house_preventive_maintenance,
              name: e.name,
              preventive_maintenance: e.preventive_maintenance,
              priority: e.priority,
              storage: e.storage,
              transportation_fees: e.transportation_fees,
              installation: e.installation,
              total:
                e.installation +
                e.transportation_fees +
                e.branding_fees +
                e.cabinet_testing_fees +
                e.corrective_reaction +
                e.corrective_service_in_house +
                e.drop +
                e.exchange_corrective_reaction +
                e.handling_in +
                e.in_house_preventive_maintenance +
                e.preventive_maintenance +
                e.storage,
            };
          });
          pricesForFinance1.push({
            corrective_reaction: "Total",
          });

          setPrices(pricesForFinance1);
        };
        setSaveClicked(2);
        fetchData();
      }
    }
  }, [pricesForFinance]);

  const handleSaveForm = async () => {
    let addresses = {};
    if (saveClicked === 1) {
      selectedSn.forEach(async (e, index) => {
        if (
          formValues.operationType === "Preventive Maintenance" ||
          formValues.operationType === "Corrective Maintenance" ||
          formValues.operationType === "Inspection" ||
          formValues.operationType === "Testing"
        ) {
          formValues[[e.location]] = e.location_id;
        }

        let allocationRules2 = [];
        let formValuesinString = Object.entries({...formValues, client: e.client, cabinetTypeId: e.type})
          .map((e) => e.join("="))
          .join("&");
        let priceRules2 = await axios(
          `${process.env.REACT_APP_BASE_URL}/priceRules/filterTop?${formValuesinString}`,
          {
            responseType: "json",
            headers: {Authorization: `Bearer ${token}`},
          }
        ).then((response) => {
          return response.data;
        });
        await axios(`${process.env.REACT_APP_BASE_URL}/allocationRules/filterTop?${formValuesinString}`, {
          responseType: "json",
          headers: {Authorization: `Bearer ${token}`},
        }).then((response) => {
          allocationRules2 = response.data;
        });
        const clientName = clientsList.filter((eSub) => eSub._id == e.client)
          ? clientsList.filter((eSub) => eSub._id == e.client)[0]?.name
          : null;
        addresses = {};
        if (formValues.operationType === "Retrieval") {
          let getShop =
            e.location === "warehouse"
              ? warehousesList?.filter((eSub) => eSub._id === e.location_id)[0]
              : storesList?.filter((eSub) => eSub._id === e.location_id)[0];

          addresses = {
            initiation_address: getShop.location
              ? {
                  _id: getShop._id,
                  city_id: getShop.location.city_id,
                  neighbourhood_id: getShop.location.neighbourhood_id,
                  shop_name: getShop.name,
                  mobile: getShop.location.mobile,
                  code: getShop.code,
                }
              : {},

            execution_address: toWarehouseValue.location
              ? {
                  _id: toWarehouseValue._id,
                  city_id: toWarehouseValue.location.city_id,
                  neighbourhood_id: toWarehouseValue.location.neighbourhood_id,
                  shop_name: toWarehouseValue.name,
                  mobile: toWarehouseValue.location.mobile,
                  code: toWarehouseValue.code,
                }
              : {},
          };
        } else if (
          formValues.operationType === "Normal Receive" ||
          formValues.operationType === "Warehouse To Warehouse"
        ) {
          addresses = {
            initiation_address: fromWarehouseValue.location
              ? {
                  _id: fromWarehouseValue._id,
                  city_id: fromWarehouseValue.location.city_id,
                  neighbourhood_id: fromWarehouseValue.location.neighbourhood_id,
                  shop_name: fromWarehouseValue.name,
                  mobile: fromWarehouseValue.location.mobile,
                  code: fromWarehouseValue.code,
                }
              : {},
            execution_address: toWarehouseValue.location
              ? {
                  _id: toWarehouseValue._id,
                  city_id: toWarehouseValue.location.city_id,
                  neighbourhood_id: toWarehouseValue.location.neighbourhood_id,
                  shop_name: toWarehouseValue.name,
                  mobile: toWarehouseValue.location.mobile,
                  code: toWarehouseValue.code,
                }
              : {},
          };
        } else if (
          formValues.operationType === "Deployment" ||
          formValues.operationType === "Exchange" ||
          formValues.operationType === "D2D"
        ) {
          addresses = {
            initiation_address: warehouseValue.location
              ? {
                  _id: warehouseValue._id,
                  city_id: warehouseValue.location.city_id,
                  neighbourhood_id: warehouseValue.location.neighbourhood_id,
                  shop_name: warehouseValue.name,
                  mobile: warehouseValue.location.mobile,
                  code: warehouseValue.code,
                }
              : {},

            execution_address1: store1Value.location
              ? {
                  _id: store1Value._id,
                  city_id: store1Value.location.city_id,
                  neighbourhood_id: store1Value.location.neighbourhood_id,
                  shop_name: store1Value.name,
                  mobile: store1Value.location.mobile,
                  code: store1Value.code,
                }
              : {},

            execution_address: storeValue.location
              ? {
                  _id: storeValue._id,
                  city_id: storeValue.location.city_id,
                  neighbourhood_id: storeValue.location.neighbourhood_id,
                  shop_name: storeValue.name,
                  mobile: storeValue.location.mobile,
                  code: storeValue.code,
                }
              : {},
          };
        } else if (formValues.operationType === "Transfer") {
          addresses = {
            initiation_address: store1Value.location
              ? {
                  _id: store1Value._id,
                  city_id: store1Value.location.city_id,
                  neighbourhood_id: store1Value.location.neighbourhood_id,
                  shop_name: store1Value.name,
                  mobile: store1Value.location.mobile,
                  code: store1Value.code,
                }
              : {},
            execution_address: storeValue.location
              ? {
                  _id: storeValue._id,
                  city_id: storeValue.location.city_id,
                  neighbourhood_id: storeValue.location.neighbourhood_id,
                  shop_name: storeValue.name,
                  mobile: storeValue.location.mobile,
                  code: storeValue.code,
                }
              : {},
          };
        } else if (
          formValues.operationType === "Preventive Maintenance" ||
          formValues.operationType === "Corrective Maintenance" ||
          formValues.operationType === "Inspection" ||
          formValues.operationType === "Testing"
        ) {
          let getShop =
            e.location === "warehouse"
              ? warehousesList.filter((eSub) => eSub._id === e.location_id)[0]
              : storesList.filter((eSub) => eSub._id === e.location_id)[0];
          addresses = {
            initiation_address: getShop.location
              ? {
                  _id: getShop._id,
                  city_id: getShop.location.city_id,
                  neighbourhood_id: getShop.location.neighbourhood_id,
                  shop_name: getShop.name,
                  mobile: getShop.location.mobile,
                  code: getShop.code,
                }
              : {},
          };
        }
        const cbm = fridgesTypesList.find((eSub) => eSub._id == e.type)
          ? fridgesTypesList.find((eSub) => eSub._id == e.type).cbm
          : 0;
        let pricesToSave = {
          price_rule_name: priceRules2 ? priceRules2.name : "-",
          branding_fees: priceRules2 ? priceRules2.branding_fees : 0,
          cabinet_testing_fees: priceRules2 ? priceRules2.cabinet_testing_fees : 0,
          corrective_reaction: priceRules2 ? priceRules2.corrective_reaction : 0,
          corrective_service_in_house: priceRules2 ? priceRules2.corrective_service_in_house : 0,
          drop: priceRules2 ? priceRules2.drop : 0,
          exchange_corrective_reaction: priceRules2 ? priceRules2.exchange_corrective_reaction : 0,
          handling_in: priceRules2 ? priceRules2.handling_in : 0,
          in_house_preventive_maintenance: priceRules2 ? priceRules2.in_house_preventive_maintenance : 0,
          min_charge: priceRules2 ? priceRules2.min_charge : 0,
          name: priceRules2 ? priceRules2.name : 0,
          preventive_maintenance: priceRules2 ? priceRules2.preventive_maintenance : 0,
          priority: priceRules2 ? priceRules2.priority : 0,
          storage: priceRules2 ? priceRules2.storage : 0,
          transp_cbm: priceRules2 ? priceRules2.transp_cbm : 0,
          transp_for_1_unit: priceRules2 ? priceRules2.transp_for_1_unit : 0,

          installation: priceRules2 ? priceRules2.installation * cbm : 0,
        };
        let transportationFeez = priceRules2
          ? selectedSn.length === 1
            ? priceRules2.transp_for_1_unit
            : cbm * priceRules2.transp_cbm
          : 0;

        setValuesFiltered((valuesFiltered) => [
          ...valuesFiltered,
          {
            line_number: index + 1,
            job_number: props.jobNumber,
            operation_number: "ON" + Math.floor(Math.random() * 100000000) + 1,
            operation_type: formValues.operationType,
            sn: e._id,
            brand: e.brand,
            client_id: e.client,
            client_name: clientName,
            ...addresses,
            allocation_rule: allocationRules2
              ? {
                  allocation_id: allocationRules2._id,
                  name: allocationRules2.name,
                }
              : {},
            price_rule: priceRules2
              ? {
                  price_id: priceRules2._id,
                  name: priceRules2.name,
                }
              : {},
            supplier_id: allocationRules2 ? allocationRules2.supplier_id : "",
            status: allocationRules2 ? "Assigned" : "Unassigned",
            last_status_user: "-",
            last_status_update: currentDate,
            promise_date: moment().add(priceRules2.promise_day, "days"),

            serviceType: serviceTypeValue,

            with_3pl_fleet: formValues.with_3pl_fleet,
          },
        ]);
        setPricesForFinance((pricesForFinance) => [
          ...pricesForFinance,
          {
            validPrice: priceRules2,
            sn: e._id,
            client_id: e.client,
            client_name: clientName,
            ...pricesToSave,
            cbm: cbm,
            transportation_fees: transportationFeez,
          },
        ]);
      });
    } else if (saveClicked === 2) {
      const fetchData = async () => {
        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/liveOperations`,
          headers: {Authorization: `Bearer ${token}`},
          data: valuesFiltered,
        })
          .then(function (response) {
            props.setItemsUpdated(valuesFiltered);

            console.log("===>", response.data.data[0]);
            if (formValues.replacement == 1 && activeStep == 0) {
              setActiveStep(1);
              setFormValues((prev) => ({
                ...prev,
                operationType: "Deployment",
                warehouse: response.data.data[0]?.execution_address?._id,
                to_warehouse: "",
                from_warehouse: "",
                store: response.data.data[0]?.initiation_address?._id,
                store1: "",
                replacement: 1,
                with_3pl_fleet: 1,
              }));

              const initiation_address = response.data.data[0]?.initiation_address;
              const execution_address = response.data.data[0]?.execution_address;

              setWarehouseValue({
                ...execution_address,
                location: {
                  city_id: execution_address.city_id,
                  neighbourhood_id: execution_address.neighbourhood_id,
                  mobile: execution_address.mobile,
                },

                name: execution_address?.shop_name,
              });

              setStoreValue({
                ...initiation_address,

                location: {
                  city_id: initiation_address.city_id,
                  neighbourhood_id: initiation_address.neighbourhood_id,
                  mobile: initiation_address.mobile,
                },

                name: initiation_address?.shop_name,
              });

              setSnFilled([]);
              setSelectedSn([]);
            } else {
              props.setOpenDialog(false);
            }
            toast.success("Successfully Added", {onClose: () => handleCloseOpenPrices()});
          })
          .catch((error) => {
            console.log(error);
          });

        let locationToDb = "";
        let locationIdToDb = "";
        let locationForHistory = "";
        if (formValues.operationType == "Deployment") {
          locationToDb = "store";
          locationIdToDb = storeValue._id;
          locationForHistory = storeValue.location;
        } else if (formValues.operationType == "Transfer") {
          locationToDb = "store";
          locationIdToDb = store1Value._id;
          locationForHistory = store1Value.location;
        } else if (
          formValues.operationType === "Normal Receive" ||
          formValues.operationType === "Retrieval"
        ) {
          locationToDb = "warehouse";
          locationIdToDb = toWarehouseValue._id;
          locationForHistory = toWarehouseValue.location;
        }

        const statusHistoryUnassigned = valuesFiltered.map((e) => ({
          status: "Unassigned",
          user: "User 1",
          notes: "",
          sn: e.sn,
          operation_number: e.operation_number,
          location: locationForHistory,
        }));
        const statusHistoryAssigned = valuesFiltered.map((e) => {
          if (e.status === "Assigned") {
            return {
              status: "Assigned",
              supplier_id: e.supplier_id,
              user: "User 1",
              notes: "",
              sn: e.sn,
              operation_number: e.operation_number,
              location: locationForHistory,
            };
          }
        });
        // let statusHistory=[...statusHistoryAssigned,...statusHistoryUnassigned]

        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/operations/history`,
          headers: {Authorization: `Bearer ${token}`},
          data: statusHistoryUnassigned,
        });
        await axios({
          method: "POST",
          url: `${process.env.REACT_APP_BASE_URL}/operations/history`,
          headers: {Authorization: `Bearer ${token}`},
          data: statusHistoryAssigned,
        });

        // selectedSn.forEach((e) => {
        //   axios({
        //     method: "PUT",
        //     url: `${process.env.REACT_APP_BASE_URL}/cabinets/${e._id}`,
        //     headers: {Authorization: `Bearer ${token}`},
        //     data: [
        //       {
        //         location: locationToDb === "" ? e.location : locationToDb,
        //         location_id: locationIdToDb === "" ? e.location_id : locationIdToDb,
        //         booked: true,
        //       },
        //     ],
        //   });
        // });
      };
      fetchData();
    }
  };
  useEffect(() => {
    console.log(formValues, snFilled);
  }, [formValues, snFilled]);

  return (
    <Fragment>
      <ToastContainer />
      <AppBar className={classes.appBar}>
        <Toolbar>
          <Close onClick={() => props.setOpenDialog(false)} className="btnIcon" />
          <Typography variant="h6" className={classes.title}>
            Add
          </Typography>
          <div>
            <strong>Date: </strong> <Moment format="DD MMM YYYY - HH:mm">{currentDate}</Moment>
          </div>
        </Toolbar>
      </AppBar>
      <Grid container spacing={3} justify="center" alignContent="center">
        {formValues.replacement ? (
          <Box sx={{width: "100%"}}>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </Box>
        ) : (
          <></>
        )}

        {loading ? (
          <CircularProgress size={30} className="pageLoader" />
        ) : (
          <Grid item xs={11}>
            <FormControl className={classes.formControl}>
              <InputLabel id="initiationAddressLabel">Operation Type</InputLabel>
              <Select
                labelId="initiationAddressLabel"
                id="initiationAddressInput"
                name="operationType"
                value={formValues.operationType || ""}
                onChange={handleChangeTextfield}
              >
                {operationsList.map((e) => (
                  <MenuItem value={e.name} key={e._id}>
                    {e.name}
                  </MenuItem>
                ))}

                <MenuItem value={"Swap"} key={"swap"}>
                  Swap
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        )}

        {formValues.operationType == "Deployment" || formValues.operationType == "Warehouse To Warehouse" ? (
          <Grid item xs={11}>
            <FormControl className={classes.formControl}>
              <InputLabel id="condition">Condition</InputLabel>
              <Select
                labelId="condition"
                id="condition"
                name="condition"
                value={formValues.condition || ""}
                onChange={handleChangeValue}
              >
                <MenuItem value={"New"} key={"New"}>
                  New
                </MenuItem>

                <MenuItem value={"Used"} key={"Used"}>
                  Used
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <></>
        )}

        {formValues.operationType == "Warehouse To Warehouse" ? (
          <Grid item xs={11}>
            <FormControl className={classes.formControl}>
              <InputLabel id="condition">Status</InputLabel>
              <Select
                labelId="status"
                id="status"
                name="status"
                value={formValues.status || ""}
                onChange={handleChangeValue}
              >
                {statusList.map((e, i) => (
                  <MenuItem value={e} key={i}>
                    {e}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ) : (
          <></>
        )}

        {formValues.operationType == "Normal Receive" ? (
          <Grid item xs={11}>
            <Autocomplete
              id="FromWarehouseInput"
              options={warehousesList ? warehousesList?.filter((w) => w.type_id == 2) ?? [] : []}
              value={fromWarehouseValue || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "from_warehouse")}
              renderInput={(params) => <TextField {...params} label="Initiation Address (Customer Site)" />}
            />
          </Grid>
        ) : null}

        {formValues.operationType == "Warehouse To Warehouse" ? (
          <Grid item xs={11}>
            <Autocomplete
              id="FromWarehouseInput"
              options={warehousesList ? warehousesList.filter((w) => w.type_id == 1) : []}
              value={fromWarehouseValue || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "from_warehouse")}
              renderInput={(params) => <TextField {...params} label="Initiation Address (Warehouse)" />}
            />
          </Grid>
        ) : null}

        {formValues.operationType &&
        formValues.operationType != "Preventive Maintenance" &&
        formValues.operationType != "Corrective Maintenance" &&
        formValues.operationType != "Inspection" &&
        formValues.operationType != "Transfer" &&
        formValues.operationType != "Testing" &&
        formValues.operationType != "Normal Receive" &&
        formValues.operationType != "Retrieval" &&
        formValues.operationType != "Warehouse To Warehouse" ? (
          <Grid item xs={11}>
            <Autocomplete
              id="WarehouseInput"
              options={warehousesList || {}}
              value={warehouseValue || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "warehouse")}
              renderInput={(params) => <TextField {...params} label="Initiation Address (Warehouse)" />}
            />
          </Grid>
        ) : null}

        {formValues.operationType == "Normal Receive" ||
        formValues.operationType == "Retrieval" ||
        formValues.operationType == "Warehouse To Warehouse" ? (
          <Grid item xs={11}>
            <Autocomplete
              id="ToWarehouseInput"
              options={warehousesList ? warehousesList?.filter((w) => w.type_id == 1) ?? [] : []}
              value={toWarehouseValue || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "to_warehouse")}
              renderInput={(params) => <TextField {...params} label="Execution Address (Warehouse)" />}
            />
          </Grid>
        ) : null}
        {formValues.operationType === "Transfer" ||
        formValues.operationType === "Exchange" ||
        formValues.operationType === "D2D" ? (
          <Grid item xs={11}>
            <Autocomplete
              id="store1Input"
              options={storesList || {}}
              value={store1Value || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "store1")}
              renderInput={(params) => <TextField {...params} label="Initiation Address (Store)" />}
            />
          </Grid>
        ) : null}

        {(formValues.warehouse &&
          formValues.operationType != "Normal Receive" &&
          formValues.operationType != "Warehouse To Warehouse" &&
          formValues.operationType != "Retrieval") ||
        (formValues.store1 &&
          (formValues.operationType === "Transfer" ||
            formValues.operationType === "Exchange" ||
            formValues.operationType === "D2D")) ? (
          <Grid item xs={11}>
            <Autocomplete
              id="storeInput"
              options={storesList || {}}
              value={storeValue || {}}
              getOptionLabel={(option) => {
                return Object.keys(option).length !== 0 ? option.name + " - " + option.code : "";
              }}
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "store")}
              renderInput={(params) => <TextField {...params} label="Execution Address (Store)" />}
            />
          </Grid>
        ) : null}

        {formValues.operationType == "Warehouse To Warehouse" && formValues.condition && formValues.status ? (
          <>
            <Grid item xs={6}>
              <FormControl className={classes.formControl}>
                <InputLabel id="fridgesType">Fridge Type</InputLabel>
                <Select
                  labelId="fridgesType"
                  id="fridgesType"
                  name="fridgesType"
                  value={formValues.fridgesType || ""}
                  onChange={handleChangeValue}
                >
                  {fridgesTypesList.map((e, i) => (
                    <MenuItem value={e._id} key={i}>
                      {e.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={3}>
              <TextField
                id="quantity"
                label="Quantity"
                name="quantity"
                onChange={handleChangeValue}
                fullWidth
                value={formValues.quantity || ""}
              />
            </Grid>
            <Grid item xs={2}>
              <Button
                fullWidth
                variant="outlined"
                color="primary"
                size="large"
                className="btn btn--save"
                onClick={handleAddSns}
                startIcon={<Add />}
              >
                Add
              </Button>
            </Grid>
          </>
        ) : (
          <></>
        )}

        {formValues.store ||
        (formValues.from_warehouse &&
          formValues.to_warehouse &&
          formValues.operationType === "Warehouse To Warehouse") ||
        (formValues.from_warehouse &&
          formValues.to_warehouse &&
          formValues.operationType === "Normal Receive") ||
        (formValues.to_warehouse && formValues.operationType === "Retrieval") ||
        formValues.operationType === "Preventive Maintenance" ||
        formValues.operationType === "Corrective Maintenance" ||
        formValues.operationType === "Inspection" ||
        formValues.operationType === "Testing" ? (
          <Grid item xs={11} container>
            <Fragment>
              {formValues.operationType == "Warehouse To Warehouse" ? (
                Object.entries(groupSNsByType(selectedSn)).map(([type, snList], idx) => (
                  <Grid item xs={12} key={idx}>
                    <Typography variant="subtitle1" gutterBottom>
                      {fridgesTypesList.find((t) => t._id == type)?.name} ({snList.length})
                    </Typography>
                    <Autocomplete
                      multiple
                      fullWidth
                      freeSolo
                      id={`snSelect-${type}`}
                      value={snList}
                      options={[]} // or some suggestions if needed
                      getOptionLabel={(option) => option}
                      // onChange={(event, newValue) => handleGroupedChange(type, newValue)}
                      onChange={(e, v) => handleChangeSn(e, v, type)}
                      renderInput={(params) => (
                        <TextField {...params} variant="standard" label={`Serial numbers`} placeholder="" />
                      )}
                    />
                  </Grid>
                ))
              ) : (
                <Grid item xs={10}>
                  <Autocomplete
                    multiple
                    fullWidth
                    freeSolo
                    id="snSelect"
                    value={snFilled}
                    options={[]}
                    getOptionLabel={(option) => option}
                    onChange={handleChangeSn}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" placeholder="Add Sn" label="Serial numbers" />
                    )}
                  />
                </Grid>
              )}

              {formValues.operationType != "Warehouse To Warehouse" && (
                <Grid item xs={2}>
                  <Button
                    fullWidth
                    variant="outlined"
                    color="primary"
                    size="large"
                    className="btn btn--save"
                    onClick={handleOpenSearch}
                    startIcon={<Search />}
                  >
                    Search
                  </Button>
                </Grid>
              )}
            </Fragment>
          </Grid>
        ) : null}
        {formValues.store ||
        (selectedSn.length && formValues.operationType === "Preventive Maintenance") ||
        (selectedSn.length && formValues.operationType === "Corrective Maintenance") ||
        (selectedSn.length && formValues.operationType === "Inspection") ||
        (selectedSn.length && formValues.operationType === "Testing") ||
        (formValues.from_warehouse &&
          formValues.to_warehouse &&
          formValues.operationType === "Normal Receive") ||
        (formValues.to_warehouse && formValues.operationType === "Retrieval") ||
        (formValues.from_warehouse &&
          formValues.to_warehouse &&
          formValues.operationType === "Warehouse To Warehouse") ? (
          <Grid item xs={11}>
            <Autocomplete
              id="serviceTypeInput"
              options={serviceTypeList || {}}
              value={serviceTypeValue || {}}
              getOptionLabel={(option) =>
                Object.keys(option).length !== 0 ? option.name + " - " + option.code : ""
              }
              fullWidth
              onChange={(e, newValue) => handleChangeAutoComplete(e, newValue, "serviceType")}
              renderInput={(params) => <TextField {...params} label="Service Type" />}
            />
          </Grid>
        ) : null}

        {formValues.operationType &&
          formValues.operationType != "Corrective Maintenance" &&
          formValues.operationType != "Inspection" &&
          formValues.operationType != "Preventive Maintenance" && (
            <>
              <Grid item xs={6} sm={6}>
                <FormControlLabel
                  style={{marginLeft: 30}}
                  control={
                    <Switch
                      checked={!!formValues.with_3pl_fleet}
                      onChange={handleChangeCheckbox}
                      name="with_3pl_fleet"
                      color="primary"
                    />
                  }
                  label={formValues.with_3pl_fleet ? "Assign to Fridgeit" : "Use Client Fleet"}
                />
              </Grid>
              <Grid item xs={6} sm={6}></Grid>
              {/* <Grid item xs={12} sm={12}>
                <FormControlLabel
                  style={{marginLeft: 30}}
                  control={
                    <Checkbox
                      checked={formValues.with_3pl_fleet ? true : false}
                      onChange={handleChangeCheckbox}
                      name="with_3pl_fleet"
                      color="primary"
                    />
                  }
                  label="With 3PL Fleet"
                />
              </Grid> */}
              {/* {formValues.operationType == "Retrieval" || formValues.operationType == "Deployment" ? (
                <Grid item xs={6} sm={6}>
                  <FormControlLabel
                    style={{marginLeft: 30}}
                    control={
                      <Checkbox
                        checked={formValues.replacement ? true : false}
                        onChange={handleChangeCheckbox}
                        name="replacement"
                        color="primary"
                      />
                    }
                    label="Replacement"
                  />
                </Grid>
              ) : (
                <Grid item xs={6} sm={6}>
                  {" "}
                </Grid>
              )} */}
            </>
          )}
        {formValues.serviceType ? (
          <Grid item xs={11} className="clientTables">
            <Button
              variant="contained"
              color="primary"
              size="large"
              className="btn btn--save"
              onClick={handleSaveForm}
              startIcon={<Save />}
            >
              Submit
            </Button>
            <Button
              variant="outlined"
              color="primary"
              size="large"
              className="btn btn--save"
              onClick={() => props.setOpenDialog(false)}
              startIcon={<Close />}
            >
              Close
            </Button>
          </Grid>
        ) : null}
      </Grid>

      <div>
        {/*********************** -Operation Dialog START- ****************************/}
        <Dialog maxWidth={"xl"} fullWidth open={openSearch} onClose={() => setOpenSearch(false)}>
          <MUIDataTable
            title="Operation"
            data={cabinetsList}
            columns={[
              {
                name: "_id",
                options: {
                  display: false,
                },
              },
              {name: "sn"},
              {name: "sn2"},
              {
                name: "type",
                options: {
                  customBodyRender: (value, tableMeta, updateValue) => {
                    let typeValue = "-";
                    if (fridgesTypesList.filter((e) => e._id === value)[0]) {
                      typeValue = fridgesTypesList.filter((e) => e._id == value)[0].refrigerant_type;
                    }
                    return typeValue;
                  },
                },
              },
              {
                name: "client",
                options: {
                  customBodyRender: (value, tableMeta, updateValue) =>
                    clientsList.filter((e) => e._id === value)[0]
                      ? clientsList.filter((e) => e._id == value)[0]?.name
                      : "-",
                },
              },
              {name: "condition"},
              {name: "status"},
              {name: "prev_status"},
              {name: "finance"},
              {
                name: "location",
                label: "Location Type",
              },
              {
                name: "location_name",
                label: "Location Name",
              },
              {
                name: "location_id",
                label: "address",
                options: {
                  customBodyRender: (value, tableMeta, updateValue) => {
                    let cityValue = "-";
                    let neighbourhoodValue = "-";
                    let mobileValue = "-";
                    let name = "-";
                    if (tableMeta.rowData[9] === "store") {
                      if (storesList.filter((e) => e._id == value)[0]) {
                        let locationValue = storesList.filter((e) => e._id == value)[0].location;

                        name = storesList.filter((e) => e._id == value)[0].name;

                        if (citiesList.filter((e) => e._id == locationValue.city_id)[0]) {
                          cityValue = citiesList.filter((e) => e._id == locationValue.city_id)[0]?.name;
                        }
                        if (neighbourhoodsList.filter((e) => e._id == locationValue.neighbourhood_id)[0]) {
                          neighbourhoodValue = neighbourhoodsList.filter(
                            (e) => e._id == locationValue.neighbourhood_id
                          )[0]?.name;
                        }
                        mobileValue = locationValue.mobile;
                      }
                    } else if (tableMeta.rowData[9] === "warehouse") {
                      let locationValue = warehousesList.filter((e) => e._id == value);
                      name = locationValue[0].name;
                      if (locationValue.length) {
                        locationValue = locationValue[0].location || "";
                        if (citiesList.filter((e) => e._id == locationValue.city_id)[0]) {
                          cityValue = citiesList.filter((e) => e._id == locationValue.city_id)[0]?.name;
                        }
                        if (neighbourhoodsList.filter((e) => e._id == locationValue.neighbourhood_id)[0]) {
                          neighbourhoodValue = neighbourhoodsList.filter(
                            (e) => e._id == locationValue.neighbourhood_id
                          )[0]?.name;
                        }
                        mobileValue = locationValue.mobile;
                      }
                    }
                    return (
                      <div style={{width: 200}}>
                        {name}
                        <br />
                        <strong>City</strong>: {cityValue}
                        <br />
                        <strong>Neighbourhood</strong>: {neighbourhoodValue}
                        <br />
                        <strong>Mobile</strong>: {mobileValue}
                        <br />
                      </div>
                    );
                  },
                },
              },
            ]}
            options={optionsForSn}
          />
        </Dialog>
        {/*********************** FILTER start ****************************/}
        <Dialog
          onClose={() => setFilterDialog(false)}
          maxWidth={"xl"}
          fullWidth
          aria-labelledby="customized-dialog-title"
          open={filterDialog}
        >
          <FilterComponent
            setOpenDialog={setFilterDialog}
            setItems={setCabinetsList}
            operationType={formValues.operationType}
            setPagingInfo={setCabinetsPagingInfo}
            pagingInfo={cabinetsPagingInfo}
          />
        </Dialog>
        {saveClicked === 2 ? (
          <Dialog maxWidth={"xl"} fullWidth open={openPrices} onClose={handleCloseOpenPrices}>
            <MuiThemeProvider theme={pricesDataTableTheme}>
              <MUIDataTable
                className="pricesDataTable"
                title="Prices"
                data={prices}
                columns={columnsForPrices}
                options={optionsForPrices}
              />
            </MuiThemeProvider>
            <div className="clientTables mx-5 my-3">
              <Button
                variant="contained"
                color="primary"
                size="large"
                className="btn btn--save"
                onClick={handleSaveForm}
                startIcon={<Save />}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                color="primary"
                size="large"
                className="btn btn--save"
                onClick={handleCloseOpenPrices}
                startIcon={<Close />}
              >
                Close
              </Button>
            </div>
          </Dialog>
        ) : null}
      </div>
    </Fragment>
  );
};

export default AddOperationForm;
